module.exports = __webpack_public_path__ + "img/game_detail_surfing10_classic.2b33c0e7.jpg";